import styled from 'styled-components';
import { fontWeight } from '@grnhse/seedling/lib/azalea/constants';

const PageHeader = styled.h2`
  ${fontWeight('heavy')}
  margin-bottom: 25px;
`;

export default PageHeader;
